import m from "mithril";
import { RecorderPage } from "./views/recorder-page";

m.mount(document.body, RecorderPage);
